import { RuntimeModel, http } from '@kunlun/dependencies';
import { graphqlQueryFormatter, stringifyToGraphql } from '../../../../utils/serialize';

const genSkuListGql = ({ isPromotionOrder }) => {
  return `
  createOrderSaleSkuList {
    promotionSimpleCode
    policyPromotionType
    planName
    id
    tradeOrderDetailId
    skuId
    rowIndex
    assemblyItemDisplay
    isAssemblyItem
    deliAriesItemSpecificationsProxyList {
      id
      pcsCount
      count
      unitName
      unitCode
      conversionRules
      isEnabled
    }
    availableNum
    code
    deliAriesInventoryStatusEnum
    barCode
    marketUnitPrice
    priceRatio
    customerDiscount
    specialityDiscount
    saleDiscount
    promotionDeductionRate
    skuId
    promotionMatch
    sortByGroup
    calcPromotionIds
    canDesignShopMatchRules {
      promotionId
      ruleName
      planName
      policyName
      prePromotionItem
      canSuperposition
      relationPromotionIds
    }
    isPromotionItem
    isCanUseCustomPrice
    isCannotChangeNum
    isGift
    isMsItem
    itemId
    promotionId
    itemCode
    itemName
    itemNumber
    itemBarCode
    priceType
    isGifted
    isExamine
    lastActualUnitPrice
    finalSettlementPrice
    itemNum
    saleUnitName
    discountAmount
    policyPromotionType
    actualAmount
    minoq
    outCode
    expectedDeliveryTime
    brandName
    productOutCode
    finalSettlementDeductionRate
    ${isPromotionOrder ? 'promotionLablesStr\n            prePromotionItem' : ''}
    accountTimeRule
    paymentDays
    accountDate
    isAllocItem
    freeReasonStr
    addCartSource
    allowDelete
    customerOriginItemNum
    itemColor
    materialGroupFour
    platformDiscount
    provinceDiscount
    productDiscount
    discountOwner
    promotionSimpleCodeObjId
  }
  `;
};

const genGql = ({ isPromotionOrder }) => {
  return `
  actualShippingFee
  actualAmount
  expectedAmount
  originAmount
  activityDiscountAmount
  manualDiscountAmount
  platformDiscountAmount
  settlementAmount
  shopDiscountAmount
  discountAmount
  heightTotal
  volumeTotal
  itemNumTotal
  madeOrderAudit
  selectGifts {
    id 
    promotionId 
    promotionName 
    isUseSelect 
    limitSelectNum 
    giftMatchDesc 
    otherMark 
    selectGifts {
      itemId 
      itemName 
      skuId
      itemNum 
      unitName 
      itemPicUrl 
      itemUnitPrice 
      giftDesc
    }
  }
  ${genSkuListGql({ isPromotionOrder })}
  `;
};
const createOrderEnums = ['cartGroupType', 'deliveryCycle', 'prepaymentRate', 'addCartSource'];

export const searchItemsByCondition = async (
  rModel: RuntimeModel,
  params: {
    data: Record<any, any>;
    pagination: Record<any, any>;
  }
) => {
  const gql = `
        mutation {
          sellerDistributionCreateOrderParamMutation {
            searchItemsByCondition(
              data: ${stringifyToGraphql(params.data, [], rModel)}
              pagination: ${stringifyToGraphql(params.pagination, [], rModel)}
            ) {
              name
              outCode
              itemId
              promotionId
              skuId
            }
          }
        }
      `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.sellerDistributionCreateOrderParamMutation.searchItemsByCondition;
};

export const quicklyAdd = async (
  rModel: RuntimeModel,
  params: { data: Record<any, any> },
  isPromotionOrder: boolean
) => {
  const gql = `
      query {
        sellerDistributionCreateOrderParamQuery {
          addItemDetail(
            data: ${stringifyToGraphql(params.data, [], rModel)}
          ) {
            errMessages
            ${genSkuListGql({ isPromotionOrder })}
          }
        }
      }
    `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.sellerDistributionCreateOrderParamQuery.addItemDetail;
};

export const orderPreviewCreate = async (
  rModel: RuntimeModel,
  params: { formData: Record<any, any> },
  isPromotionOrder: boolean
) => {
  const gql = `
    mutation {
      sellerDistributionCreateOrderParamMutation {
        previewCreateOrder (
          sellerCreateOrderParam: ${stringifyToGraphql(params.formData, createOrderEnums, rModel)}
        ) {
          errMessages
          ${genGql({ isPromotionOrder })}
        }
      }
    }
    `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.sellerDistributionCreateOrderParamMutation.previewCreateOrder;
};

export const orderPreviewAudit = async (
  rModel: RuntimeModel,
  params: { formData: Record<any, any> },
  isPromotionOrder: boolean
) => {
  const gql = `
    mutation {
      sellerDistributorAuditOrderParamMutation {
        previewAuditSuccess (
          auditOrderParam: ${stringifyToGraphql(params.formData, createOrderEnums, rModel)}
        ) {
          ${genGql({ isPromotionOrder })}
        }
      }
    }
    `;

  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.sellerDistributorAuditOrderParamMutation.previewAuditSuccess;
};

/**
 * 查询库存列表
 *
 * @param {RuntimeModel} rModel
 * @param {{ data: Record<any, any> }} params
 * @return {*}
 */
export const queryStoreList = async (rModel: RuntimeModel, params: any) => {
  const gql = `
    query {
      deliAriesOrderItemInventoryViewQuery {
        construct(
          inventoryView: ${stringifyToGraphql(params, ['ariesIssuingMethodEnum', 'bizType'])}
        ) {
          shopId
          sellerPartnerId
          orderDetailDesc
          bizType
          inventoryList {
            id
            itemCode
            ariesIssuingMethodEnum
            itemOutCode
            outOwnerCode
            itemTplCode
            saleUnitCode
            quantity
            unAllocInvNum
            allocInvNum
            warehouseKind
            warehousePriority
            warehouse {
              name
              code
              outCode
            }
            availableNum
            blockedNum
            totalNum
          }
        }
      }
    }
  `;
  const res = await http.query<{ orderDetailDesc: string; inventoryList: any[] }>(
    rModel.moduleName,
    graphqlQueryFormatter(gql)
  );

  return res.data.deliAriesOrderItemInventoryViewQuery.construct;
};
